<div class="solori-bck-img signin-box-container ui-g">
  <div class="signin-box-inner-container">
    <div class="signin-box ">
      <div class="sign-comatiner">
        <div class="solari-logo"><img src="/assets/images/temp/solari_logo_new.png" width="25%"></div>
        <div class="signin-box ui-md-4 ui-md-offset-4">
          <div class="forgot-pass-form">
            <div class="form-field ui-g-12 ui-g-nopad">
              <div class="form-field ui-g-12 ui-g-nopad text-center">
                <div class="powered_by"><span class="poweredbytxt">Powered By:</span> </div>
                <a href="https://www.rainbow.health/" target="_blank"><img class="company-logo-background"
                    src='./assets/images/temp/rainbowcare_logo.png'></a>
              </div>
              <div class="form-field ui-g-12 switch-pass" translate>label_reset_password</div>
              <div class="form-field ui-g-12"></div>
            </div>
            <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
              <form [formGroup]='setPasswordForm'>
                <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
                  <div class="form-label">
                    <label for="newPassword" translate>label_new_password</label>
                  </div>
                  <div class="form-control-c password-field-with-eye">
                    <input autocomplete="off" class="bottom-border" appNoWhiteSpace [type]="inputType"
                      formControlName="newPassword" pInputText />
                    <span class="eye-icon sign-in-eye" (click)="tooglePasswordType()">
                      <i *ngIf="inputType === 'password'" class="fa fa-eye-slash" aria-hidden="true"></i>
                      <i *ngIf="inputType !== 'password'" class="fa fa-eye" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="form-errors"
                    *ngIf="setPasswordForm.controls.newPassword.errors  && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
                    <div [hidden]="!setPasswordForm.controls.newPassword.errors.required" translate>
                      error_new_password_required
                    </div>
                    <div [hidden]="(!setPasswordForm.controls.newPassword.errors.minlength)
                 && (!setPasswordForm.controls.newPassword.errors.pattern)" translate>
                      error_password_pattern
                    </div>
                    <div [hidden]="!setPasswordForm.controls.newPassword.errors.maxlength" translate>
                      exceed_max_length
                    </div>
                  </div>
                </div>

                <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
                  <div class="form-label">
                    <label for="newConfirmPassword" translate>label_new_confirm_password</label>
                  </div>
                  <div class="form-control-c password-field-with-eye">
                    <input autocomplete="off" class="bottom-border" appNoWhiteSpace [type]="cnfinputType"
                      formControlName="newConfirmPassword" pInputText />
                    <span class="eye-icon sign-in-eye" (click)="toogleCnfPasswordType()">
                      <i *ngIf="cnfinputType === 'password'" class="fa fa-eye-slash" aria-hidden="true"></i>
                      <i *ngIf="cnfinputType !== 'password'" class="fa fa-eye" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="form-errors"
                    *ngIf="setPasswordForm.controls.newConfirmPassword.errors  && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
                    <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required" translate>
                      error_new_confirm_password_required
                    </div>
                    <div [hidden]="(!setPasswordForm.controls.newConfirmPassword.errors.minlength)
                 && (!setPasswordForm.controls.newConfirmPassword.errors.pattern)" translate>
                      error_password_pattern
                    </div>
                    <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.maxlength" translate>
                      exceed_max_length
                    </div>
                  </div>
                </div>

                <!-- <div class="ui-g"> -->
                <div class="form-field ui-g-12 UI-MD-12 ui-lg-12">
                  <div class="form-errors alert alert-danger" [hidden]='!passwordError[0]["general"]'>
                    <div *ngFor="let ErrorMessage of passwordError['general']">
                      {{ErrorMessage.message}}
                    </div>
                  </div>
                </div>
                <!-- </div> -->

                <div class="form-field ui-g-12" style="margin-left: 10px;">
                  <div class="form-buttons ui-g-12 ui-g-nopad frgt-pass">
                    <button pButton label="Save" class='signin-save-btn' type="button"
                      [disabled]="!setPasswordForm.valid" (click)="doChangePassword()"></button>
                    <div class="form-field ui-g-12 ui-md-12 ui-lg-12 back-to-lgn text-center">
                      <span>Back to <a style="cursor: pointer;" (click)="onBackSign($event)">Login</a></span>
                    </div>
                  </div>
                </div>

              </form>
            </div>
            <div class="remove-float"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
